module.exports = __webpack_public_path__ + "img/DE03958.e3e52305.png";